import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { structureContainerIds } from '@Pages/StructureEditor/StructureEditorConstants';
import StructureContainers from '@Services/StructureContainers';

import { updateFilterById } from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersActions';
import { keyifyParamsForFiltersRequest } from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';
import StructureFilter from './StructureFilter';

import {
  goToEditor as goToEditorAction,
  unselectFilter as unselectFilterAction,
  setExpandedFilter as setExpandedFilterAction,
  setStructureOptions as setStructureOptionsAction,
  setDrawingFromResults as setDrawingFromResultsAction,
  initializeStructureFilter as initializeStructureFilterAction,
  openStructureOptionsDialog as openStructureOptionsDialogAction,
  setSelectedAndExpandedFilter as setSelectedAndExpandedFilterAction,
  clearStructureFilter as clearStructureFilterAction,
} from './StructureFilterActions';

import {
  drawing as drawingSelector,
  selectedOptionTitles as selectedOptionTitlesSelector,
  selectedOptionsNameValueObjectsArray as selectedOptionsNameValueObjectsArraySelector,
} from './StructureFilterSelectors';

import withAccordionForFilter from '../withAccordionForFilter';

import withStructureFilterLifecycle from './withStructureFilterLifecycle';

export function StructureFilterContainer(props) {
  const { drawing, goToEditor, keyifyParams, clearStructureFilter, filter, openStructureOptionsDialog } = props;
  const onClick = useCallback(() => {
    if (drawing) {
      return;
    }
    const { structureFilter: structureUID } = structureContainerIds;
    StructureContainers.removeContainerByUID(structureUID);
    goToEditor();
  }, [drawing]);
  const clearDrawn = useCallback(() => {
    clearStructureFilter({ key: keyifyParams, filter });
  }, [filter, keyifyParams]);
  const drawOnClick = useCallback(() => {
    goToEditor();
  }, []);
  const optionsButtonOnClick = useCallback(() => {
    openStructureOptionsDialog();
  }, []);

  return (
    <StructureFilter
      {...props}
      onClick={onClick}
      clearDrawn={clearDrawn}
      drawOnClick={drawOnClick}
      optionsButtonOnClick={optionsButtonOnClick}
    />
  );
}

StructureFilterContainer.propTypes = {
  drawing: PropTypes.object,
  goToEditor: PropTypes.func,
  keyifyParams: PropTypes.string,
  clearStructureFilter: PropTypes.func,
  filter: PropTypes.instanceOf(Map),
  openStructureOptionsDialog: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    drawing: drawingSelector(state),
    keyifyParams: keyifyParamsForFiltersRequest(state),
    selectedOptionTitles: selectedOptionTitlesSelector(state),
    selectedOptionsNameValueObjectsArray: selectedOptionsNameValueObjectsArraySelector(state),
  };
}

const mapDispatchToProps = {
  goToEditor: goToEditorAction,
  unselectFilter: unselectFilterAction,
  updateFilterById,
  setExpandedFilter: setExpandedFilterAction,
  setStructureOptions: setStructureOptionsAction,
  setDrawingFromResults: setDrawingFromResultsAction,
  initializeStructureFilter: initializeStructureFilterAction,
  setSelectedAndExpandedFilter: setSelectedAndExpandedFilterAction,
  openStructureOptionsDialog: openStructureOptionsDialogAction,
  clearStructureFilter: clearStructureFilterAction,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStructureFilterLifecycle,
  withAccordionForFilter
)(StructureFilterContainer);
